import script from "./wine.vue?vue&type=script&setup=true&lang=js"
export * from "./wine.vue?vue&type=script&setup=true&lang=js"

import "./wine.vue?vue&type=style&index=0&id=1f8beefa&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f8beefa"]])

export default __exports__